export enum NotaAlteracaoTCC {
  DISP = 'DISP',
  APRO = 'APRO'
}
